import { render, staticRenderFns } from "./setttingItem.vue?vue&type=template&id=2fc80570&scoped=true"
import script from "./setttingItem.vue?vue&type=script&lang=js"
export * from "./setttingItem.vue?vue&type=script&lang=js"
import style0 from "./setttingItem.vue?vue&type=style&index=0&id=2fc80570&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc80570",
  null
  
)

export default component.exports